import React, { useEffect, useRef, useState } from "react";
import { Input, Label } from "reactstrap";
import ValidationMessages from "../validations/ValidationMessages";

const Textinput = ({
  type,
  label,
  placeholder = "",
  className = "",
  name,
  readonly,
  value,
  error,
  icon,
  disabled,
  id,
  autoFocus = false,
  onChange,
  min = 0,
  max,
  isRequredFiled = false,
  focusFlag = false, // Add focusFlag prop
  ...rest
}) => {
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null); // Create a ref for the input element

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleKeyPress = (e) => {
    if (type === "number" && !/^\d+$/.test(e.key)) {
      e.preventDefault();
    }
  };

  // Handle focus based on focusFlag
  useEffect(() => {
    if (focusFlag && inputRef.current) {
      inputRef.current.focus();
    }
  }, [focusFlag]);

  // Check if the type is "number" and the value is 0, then display "0"
  const displayValue = type === "number" && value === 0 ? "0" : value;

  return (
    <div className="mb-3">
      {label && (
        <Label htmlFor={label} className="form-label">
          {label}{" "}
          {isRequredFiled && <span className="required-text-color">*</span>}
        </Label>
      )}

      <div className="position-relative auth-pass-inputgroup mb-3">
        <Input
          type={type === "password" && open === true ? "text" : type}
          className="form-control"
          {...rest}
          placeholder={placeholder}
          readOnly={readonly}
          // value={value ? value : ""}
          value={
            displayValue !== null && displayValue !== undefined
              ? displayValue
              : ""
          }
          disabled={disabled}
          id={id}
          onChange={onChange}
          onKeyPress={handleKeyPress}
          name={name}
          min={min}
          autoFocus={autoFocus}
          invalid={error ? true : false}
          max={max}
          innerRef={inputRef} // Attach the ref to the input element
        />
        <ValidationMessages errors={error} label={label} />

        {type === "password" && (
          <button
            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
            type="button"
            id="password-addon"
            onClick={handleOpen}
          >
            <i className="ri-eye-fill align-middle"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default Textinput;
